var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D5B7A875-4E43-4AC2-9F61-583EAA359FCD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide_IBM-font",
    transform: "translate(-1392.000000, -119.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "",
    x: 0,
    y: 0,
    width: 1673,
    height: 1155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.43731,133.548633 C1412.16251,133.548633 1411.93979,133.772461 1411.93979,134.048633 L1411.93979,138.488086 C1411.93882,139.316211 1411.27126,139.987305 1410.44726,139.988086 L1396.48756,139.988086 C1395.66356,139.987305 1394.996,139.316211 1394.99502,138.488086 L1394.99502,125.458594 C1394.996,124.630664 1395.66356,123.95957 1396.48756,123.958594 L1400.90493,123.958594 C1401.17973,123.958594 1401.40244,123.734766 1401.40244,123.458594 C1401.40244,123.182617 1401.17973,122.958594 1400.90493,122.958594 L1396.48756,122.958594 C1395.11435,122.960156 1394.00155,124.078516 1394,125.458594 L1394,138.488281 C1394.00155,139.868359 1395.11435,140.986719 1396.48756,140.988281 L1410.44726,140.988281 C1411.82047,140.986719 1412.93326,139.868359 1412.93482,138.488281 L1412.93482,134.048633 C1412.93482,133.772461 1412.7121,133.548633 1412.43731,133.548633 Z",
    id: "Path",
    stroke: "#506D85",
    strokeWidth: 0.5,
    fill: "#506D85",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.73776,121.67207 C1411.86342,120.793359 1410.4459,120.793359 1409.57156,121.67207 L1400.69562,130.592383 C1400.63479,130.653516 1400.59087,130.729297 1400.56794,130.8125 L1399.40073,135.047461 C1399.35273,135.221094 1399.40151,135.407031 1399.52822,135.53457 C1399.65512,135.661914 1399.84014,135.710938 1400.0129,135.662891 L1404.2268,134.489648 C1404.30958,134.466602 1404.38499,134.422461 1404.44582,134.361328 L1413.32156,125.44082 C1414.19454,124.561523 1414.19454,123.138086 1413.32156,122.258789 L1412.73776,121.67207 Z M1401.77966,130.917383 L1409.04392,123.616602 L1411.3867,125.971094 L1404.12224,133.271875 L1401.77966,130.917383 Z M1401.31168,131.861133 L1403.18338,133.742383 L1400.59437,134.463281 L1401.31168,131.861133 Z M1412.61804,124.733789 L1412.09041,125.264062 L1409.74743,122.909375 L1410.27526,122.379102 C1410.76092,121.891016 1411.54839,121.891016 1412.03405,122.379102 L1412.61804,122.96582 C1413.10292,123.454492 1413.10292,124.245312 1412.61804,124.733789 L1412.61804,124.733789 Z",
    id: "Shape",
    stroke: "#506D85",
    strokeWidth: 0.5,
    fill: "#506D85",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDashboard);
export default __webpack_public_path__ + "static/media/edit-dashboard.6449be5c6c45f172eb7cd97308880231.svg";
export { ForwardRef as ReactComponent };